// extracted by mini-css-extract-plugin
export var checkbox = "_2m-0";
export var circle = "_2m-3";
export var horizontalContainer = "_2m-7";
export var sm = "_2m-5";
export var switch0 = "_2m-2";
export var switchDisabled = "_2m-8";
export var switchEnabled = "_2m-1";
export var textSwitchContainer = "_2m-9";
export var textSwitchOption = "_2m-a";
export var textSwitchOptionSelected = "_2m-b";
export var verticalContainer = "_2m-6";
export var xs = "_2m-4";